import React, { useState, useEffect } from "react";
import LeftSide from "./../LoginComps/LeftSide";
import RigthSide from "./../LoginComps/RigthSide";

export default function Login() {
  const [height, width] = useWindowSize();

  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }

  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "row",
      }}
    >
      <LeftSide />
      {width < 767 ? <></> : <RigthSide />}
    </div>
  );
}
